import script from "./OpenClubDeal.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenClubDeal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__